import React from 'react';

export const useUnderlineStyles = ({ activeTab }: { activeTab: number }) => {
  const [underlineStyle, setUnderlineStyle] = React.useState<React.CSSProperties>({});
  const tabsRef = React.useRef<HTMLDivElement[]>([]);

  React.useEffect(() => {
    if (tabsRef.current[activeTab]) {
      const tabsWrapper = tabsRef.current[activeTab].parentElement!.getBoundingClientRect();
      const tabElement = tabsRef.current[activeTab].getBoundingClientRect();

      setUnderlineStyle({
        width: `${tabElement.width}px`,
        left: `${tabElement.left - tabsWrapper.left}px`,
        transition: 'left 0.3s ease, width 0.3s ease',
      });
    }
  }, [activeTab]);

  return {
    tabsRef,
    underlineStyle,
  };
};
